module.exports = __webpack_public_path__ + "img/Siam_Cercle.304fa431.png";